import type { ExcDtcFilesV1FileRequestKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const DTC_DTCC_BASE_PATH = getResolvedPath('/clearing/vendor/dtcc');

export const DTC_FILE_REQUEST_BASE_PATH = getResolvedPath('/clearing/vendor/dtcc/file-request');

export const getDtcFileRequestPath: EntityPathBuilder<ExcDtcFilesV1FileRequestKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return DTC_FILE_REQUEST_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.fileRequestId) {
        return undefined;
      }

      return getResolvedPath(`${DTC_FILE_REQUEST_BASE_PATH}/$fileRequestId`, context.keys);
    }
  }
};

export function getDtcFileRequestDetailPath(fileRequestId: string | undefined) {
  if (!fileRequestId) {
    return undefined;
  }

  return getDtcFileRequestPath({ kind: 'detail', keys: { fileRequestId } });
}
